import React from 'react';
import { HiChatAlt2, HiArrowNarrowLeft, HiSparkles } from 'react-icons/hi';
import { useNavigate } from 'react-router-dom';

const QAPageBanner = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-[80vh] flex items-center justify-center p-6 bg-slate-50">
      <div className="max-w-xl w-full">
        {/* Main Card */}
        <div className="bg-white rounded-[3rem] p-8 md:p-12 shadow-2xl shadow-blue-100 border border-slate-100 text-center relative overflow-hidden">
          
          {/* Decorative Background Element */}
          <div className="absolute -top-10 -right-10 w-32 h-32 bg-blue-50 rounded-full blur-3xl opacity-50"></div>
          
          {/* Icon with Animation */}
          <div className="relative inline-block mb-8">
            <div className="w-24 h-24 bg-gradient-to-tr from-blue-600 to-indigo-500 text-white rounded-[2rem] flex items-center justify-center mx-auto shadow-xl rotate-6 animate-pulse">
              <HiChatAlt2 size={48} />
            </div>
            <div className="absolute -bottom-2 -right-2 bg-amber-400 text-white p-2 rounded-full shadow-lg">
              <HiSparkles size={20} />
            </div>
          </div>

          {/* Text Content */}
          <h2 className="text-3xl font-black text-slate-900 uppercase tracking-tighter mb-4">
            Campus <span className="text-blue-600">Discussions</span>
          </h2>
          
          <div className="inline-block px-4 py-1.5 bg-blue-50 rounded-full mb-6">
            <p className="text-blue-700 text-[10px] font-black uppercase tracking-[0.2em]">
              Status: Final Polishing ⚒️
            </p>
          </div>

          <p className="text-slate-500 font-medium leading-relaxed mb-10 px-4">
            We are building a dedicated space for <strong>CampusIRA</strong> members to share insights, ask questions, and connect across colleges. This feature is currently in the final stages of development.
          </p>

          {/* Progress Indicator */}
          <div className="flex flex-col items-center gap-3 mb-10">
            <div className="w-full max-w-xs h-2 bg-slate-100 rounded-full overflow-hidden">
              <div className="h-full bg-blue-600 rounded-full transition-all duration-1000 w-[85%]"></div>
            </div>
            <span className="text-[11px] font-bold text-slate-400 uppercase tracking-widest">
              Ready to launch soon
            </span>
          </div>

          {/* Action Button */}
          <button 
            onClick={() => navigate('/')}
            className="group flex items-center justify-center gap-2 mx-auto bg-slate-900 text-white px-8 py-4 rounded-2xl font-black text-xs uppercase tracking-widest hover:bg-blue-600 transition-all active:scale-95 shadow-lg shadow-slate-200"
          >
            <HiArrowNarrowLeft className="group-hover:-translate-x-1 transition-transform" />
            Back to Home
          </button>
        </div>

        {/* Support Footer */}
        <p className="mt-8 text-center text-slate-400 text-[11px] font-medium uppercase tracking-widest">
          Expected Launch: Spring 2026 • CampusIRA Beta
        </p>
      </div>
    </div>
  );
};

export default QAPageBanner;